
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.7377 13.4712L9.26649 8.00002L14.7377 2.52878C15.0874 2.17904 15.0874 1.61204 14.7377 1.26236C14.388 0.912624 13.8209 0.912624 13.4712 1.26236L8.00002 6.73354L2.52878 1.2623C2.1791 0.912565 1.61204 0.912565 1.2623 1.2623C0.912565 1.61204 0.912565 2.17904 1.2623 2.52878L6.73354 8.00002L1.2623 13.4712C0.912565 13.821 0.912565 14.388 1.2623 14.7377C1.43717 14.9126 1.66637 15 1.89551 15C2.12471 15 2.35391 14.9126 2.52878 14.7377L8.00002 9.26649L13.4712 14.7377C13.6461 14.9126 13.8753 15 14.1045 15C14.3337 15 14.5629 14.9126 14.7377 14.7377C15.0875 14.388 15.0875 13.821 14.7377 13.4712Z","stroke":"currentColor"}})])
          )
        }
      }
    